import { USER_ROUTE_NAME } from '@/libs/route-name';

export const userRoute = () => {
    return {
        name: USER_ROUTE_NAME.USER,
        path: 'user',
        component: () => import('@/pages/user/index.vue'),
    };
};
